<dx-popup
    #attachmentsPopup
    minWidth="150px"
    minHeight="150px"
    width="45%"
    height="50%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="true"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onAttachmentPopupShown()"
    (onHidden)="onAttachmentPopupHidden()"
>
    <div *dxTemplate="let data of 'content'" id="inventoryAttachments">
        <dx-box *ngIf="selectedAttachments" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto" [visible]="!isViewOnly">
                <div *dxTemplate>
                    <div class="attachment-button-container">
                        <div class="attach-file">
                            <dx-file-uploader
                                #fileUploader
                                labelText="Drop file here"
                                uploadMode="useButtons"
                                [accept]="acceptedFileTypes"
                                [allowedFileExtensions]="allowedFileExtensions"
                                [multiple]="multipleSelect"
                                [showFileList]="false"
                                [maxFileSize]="4000000"
                                [visible]="false"
                                (onValueChanged)="onAttachmentsSelect($event)"
                            ></dx-file-uploader>
                        </div>

                        <div class="button-content" *ngIf="showAttachmentButton">
                            <dx-button
                                type="default"
                                [text]="attachLocal"
                                [hint]="attachLocal"
                                [icon]="iconPlus"
                                (onClick)="onLocalAttachment()"
                            ></dx-button>
                        </div>

                        <div class="button-content" *ngIf="showAttachmentButton">
                            <dx-button
                                *ngIf="!communityApiUrl && !!communityId"
                                type="default"
                                [hint]="attachCommunity"
                                [text]="attachCommunity"
                                [icon]="iconPlus"
                                (onClick)="onCommunityDocumentAttachment()"
                            ></dx-button>
                            <dx-button
                                *ngIf="!!communityApiUrl && isInternalUser"
                                type="default"
                                template="communityButtonTemplate"
                                [hint]="attachCommunity"
                                (onClick)="onCommunityDocumentAttachment()"
                            >
                                <div
                                    *dxTemplate="let buttonData of 'communityButtonTemplate'"
                                    class="cc-button-template"
                                >
                                    <span>
                                        <i class="add-padding" [ngClass]="iconPlus"></i>
                                        {{ attachCommunity }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="LOCK"
                                            apiAction="GET"
                                            [apiUrl]="communityApiUrl"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>

                        <div *ngIf="!!customerId && showAttachmentButton" class="button-content">
                            <dx-button
                                *ngIf="!ownerApiUrl"
                                type="default"
                                [text]="attachOwner"
                                [hint]="attachOwner"
                                [icon]="iconPlus"
                                (onClick)="onOwnerDocumentAttachment()"
                            ></dx-button>
                            <dx-button
                                *ngIf="!!ownerApiUrl && isInternalUser"
                                type="default"
                                template="ownerButtonTemplate"
                                [hint]="attachOwner"
                                (onClick)="onOwnerDocumentAttachment()"
                            >
                                <div *dxTemplate="let buttonData of 'ownerButtonTemplate'">
                                    <span>
                                        <i class="add-padding" [ngClass]="iconPlus"></i>
                                        {{ attachOwner }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="LOCK"
                                            apiAction="GET"
                                            [apiUrl]="ownerApiUrl"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #attachmentGrid
                        width="100%"
                        height="100%"
                        class="cc-vertical-center-cell-data-grid"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [dataSource]="selectedAttachments"
                        (onRowPrepared)="onRowPrepared($event)"
                        (onContentReady)="onContentReady($event)"
                    >
                        <ng-container *ngIf="allowDelete && !isViewOnly">
                            <dxi-column
                                width="50"
                                caption="Action"
                                alignment="center"
                                cellTemplate="removeFileTemplate"
                            ></dxi-column>
                        </ng-container>
                        <dxi-column
                            dataField="fileName"
                            caption="File Name"
                            cellTemplate="fileNameTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let d of 'fileNameTemplate'">
                            <app-hyperlink-creator
                                *ngIf="hasDownloadUrl(d.data) || !!d.data?.fileBase64String"
                                cssClass="cc-hyperlink-hover"
                                textLocation="right"
                                mode="hyperlinkOnly"
                                [displayText]="d.data.fileName || d.data.name"
                                (onLinkClick)="onDownloadFile(d.data)"
                            >
                                <ng-container *ngIf="d.data.fileName">
                                    <i
                                        class="cc-1-5x icon-content margin-right-5px"
                                        [ngClass]="d.data.fileName | ccFileIcon"
                                    ></i>
                                </ng-container>
                                <ng-container *ngIf="d.data.name">
                                    <i
                                        class="cc-1-5x icon-content margin-right-5px"
                                        [ngClass]="d.data.name | ccFileIcon"
                                    ></i>
                                </ng-container>
                            </app-hyperlink-creator>
                            <ng-container *ngIf="!hasDownloadUrl(d.data) && !!hasFileId(d.data)">
                                <ng-container *ngIf="d.data.fileName">
                                    <div class="flex-container">
                                        <i
                                            class="cc-1-5x icon-content margin-right-5px"
                                            [ngClass]="d.data.fileName | ccFileIcon"
                                        ></i>
                                        <div>{{ d.data.fileName }}</div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="d.data.name">
                                    <div class="flex-container">
                                        <i
                                            class="cc-1-5x icon-content margin-right-5px"
                                            [ngClass]="d.data.name | ccFileIcon"
                                        ></i>
                                        <div>{{ d.data.name }}</div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div *dxTemplate="let d of 'removeFileTemplate'">
                            <dx-button
                                type="danger"
                                stylingMode="text"
                                hint="Delete"
                                [icon]="iconRemove"
                                [disabled]="!d.data.allowDelete"
                                (onClick)="onRemoveAttachment(d)"
                            ></dx-button>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="close-button-container">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onCloseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-property-community-documents
    #propertyCommunityDocuments
    [selectionMode]="multipleSelect ? 'multiple' : 'single'"
    (onAttach)="onAttachDocuments($event)"
></app-property-community-documents>

<cc-message-box #messageBox></cc-message-box>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
